import React from 'react';
import type { FC } from 'react';
import cn from 'classnames';

import type { TPilOfferCardDesktop } from '../models';
import { FormattedValue } from '../components/formatted-value/mobile/component';
import { OfferTitle } from '../components/offer-title';
import { DEFAULT_BTN_TEXT, DEFAULT_TITLES } from '../constants';
import { BadgeDesktop as Badge } from '../components/badge/desktop';

export const PilOfferCardDesktop: FC<TPilOfferCardDesktop> = ({
    styles,
    className,
    BackgroundV2,
    Text,
    title,
    Grid,
    offerTitles = DEFAULT_TITLES,
    offerAmount,
    offerPayment,
    offerTerm,
    buttonText = DEFAULT_BTN_TEXT,
    CalculatorMIcon,
    Button,
    bgColor,
    badgeText,
    ShareCompactMIcon,
    url,
    sharingList = [],
    showCalcButton = true,
    getCorrectSuffix,
    image,
    IconButton,
    onOfferApply,
    onOfferCalculate,
    Link,
}) => {
    return (
        <div className={cn(styles.card, className)}>
            <Grid collapse columnsWidth={[178, 380]}>
                <BackgroundV2
                    className={cn(styles.bg, styles.external)}
                    color={bgColor}
                    image={image}
                    styler={{
                        borderRadius: 16,
                    }}
                >
                    <Grid
                        alignment="flexStart"
                        classNames={{
                            grid: cn(styles.external, styles.grid),
                            col: cn(styles.external, styles.colHeader),
                        }}
                        columnsWidth={[100, 24]}
                        justify="between"
                        styler={{
                            padding: 16,
                            paddingBottom: 0,
                            margin: 0,
                        }}
                    >
                        {(!!badgeText && <Badge text={badgeText} />) || <></>}
                        {/* todo: привязать функционал, когда будет понятно как это будет работать и что будет приходить */}
                        {!!sharingList.length && (
                            <IconButton
                                className={cn(styles.external, styles.btnShare)}
                                height={24}
                                width={24}
                            >
                                <ShareCompactMIcon height={24} width={24} />
                            </IconButton>
                        )}
                    </Grid>
                </BackgroundV2>
                <div className={styles.cardContent}>
                    <Text
                        className={cn(styles.cardTitle, styles.external)}
                        styler={{
                            marginTop: 0,
                            marginBottom: 24,
                        }}
                        view="small"
                    >
                        {title}
                    </Text>
                    <Grid
                        classNames={{
                            grid: styles.grid,
                            col: cn(styles.col, styles.external),
                        }}
                        collapse
                        columnsWidth={[130, 100, null]}
                        styler={{
                            marginBottom: 24,
                        }}
                    >
                        <div>
                            <OfferTitle title={offerTitles.amount} />
                            <FormattedValue value={offerAmount} />
                        </div>
                        <div>
                            <OfferTitle title={offerTitles.payment} />
                            <FormattedValue value={offerPayment} />
                        </div>
                        <div>
                            <OfferTitle title={offerTitles.term} />
                            <FormattedValue
                                suffix={getCorrectSuffix(offerTerm, {
                                    form1: 'год',
                                    form2: 'года',
                                    form3: 'лет',
                                })}
                                value={offerTerm}
                            />
                        </div>
                    </Grid>
                    <Grid
                        alignment="flexStart"
                        classNames={{
                            grid: styles.grid,
                            col: cn(styles.col, styles.external, styles.external),
                        }}
                        collapse
                        columnsWidth={[161, 40]}
                        justify="start"
                    >
                        <Link advCodes={[]} border="hidden" href={url}>
                            <Button
                                block
                                className={cn(styles.external, styles.fontSize16)}
                                dataTestId={`apply-${offerAmount}`}
                                innerClassName={cn(styles.external, styles.fontSize16)}
                                onClick={onOfferApply}
                                size="xs"
                                view="outlined"
                            >
                                {buttonText}
                            </Button>
                        </Link>
                        {showCalcButton && (
                            <Button
                                dataTestId={`calculate-${offerAmount}`}
                                innerClassName={cn(styles.external, styles.squareBtn)}
                                onClick={onOfferCalculate}
                                size="xs"
                                view="outlined"
                            >
                                <CalculatorMIcon height={24} width={24} />
                            </Button>
                        )}
                    </Grid>
                </div>
            </Grid>
        </div>
    );
};
